import { type AnswerType, clearAnswerValue, setAnswerValue } from "@formsort/custom-question-api";

// Formsort won't auto-advance if the answer value was already set,
// so we must clear before setting to support back-navigation into a question.
export const resetAnswerValue = (value: AnswerType) => {
  clearAnswerValue();
  setAnswerValue(value);
};
